var map = {
	"./client_server_convo.gif": 833,
	"./drums.gif": 2163,
	"./duolingo-randomer.gif": 4064,
	"./eventsync.gif": 2997,
	"./forwardapp.gif": 9712,
	"./habit_tracker.gif": 2615,
	"./leet_codes.gif": 3601,
	"./noimage.gif": 3968,
	"./reggiefolio.gif": 9758,
	"./snake_locomotion.gif": 3608,
	"./sosa-website.gif": 8786,
	"./timeset.gif": 6545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3847;